import React, { Component } from 'react';

import { ReadAloudContent } from '../../../Shared/components/readAloud/readAloudContent';
import { staticStringSource } from '../../../Shared/libs/speech/clipSource';
import { commonText } from '../../../Shared/libs/translations/modules/commonText';
import { ENGLISH, rightToLeftLanguages } from '../../../Shared/utils/languageList';

export interface ComponentProps {
  data: any,
  language: string,
  languageLocale: string,
  isLastQuestion: boolean,
  handleContinueClick(): void,
  previewMode: boolean,
  translate(input: string): any
}

class TitleCard extends Component<ComponentProps, any> {

  renderContent = () => {
    const { data, language, translate, languageLocale } = this.props;
    const { title } = data;
    const header = `${title}^header`;
    const text = `${title}^text`;
    const textClass = rightToLeftLanguages.includes(language) ? 'right-to-left' : '';

    return(
      <div>
        <ReadAloudContent label="Read this page aloud" source={staticStringSource('diagnostic.eslTitleCard', title)}>
          <div className="landing-page-html">
            <h1>{commonText[title].header}</h1>
            <p>{commonText[title].text}</p>
          </div>
        </ReadAloudContent>
        {language && language !== ENGLISH && <div className={`landing-page-html ${textClass}`} lang={languageLocale}>
          <h1>{translate(header)}</h1>
          <p>{translate(text)}</p>
        </div>}
      </div>
    );
  }

  render() {
    const { handleContinueClick, translate, isLastQuestion, previewMode, languageLocale } = this.props;
    const buttonText = isLastQuestion ? translate('buttons^next') : translate('buttons^continue');
    const disabled = previewMode && isLastQuestion ? 'disabled' : '';

    return (
      <div className="landing-page">
        {this.renderContent()}
        <button className={`quill-button focus-on-light large contained green ${disabled}`} lang={languageLocale} onClick={handleContinueClick} type="button">
          {buttonText}
        </button>
      </div>
    );
  }
}

export default TitleCard;
